export const SCHOOLY_MOBILE_USER_AGENT = 'com.schooly-app.mobile';
